const WrapperComponent = ({
    Wrapper, 
    children, 
    props = {},
}) => {
    return (
        <Wrapper {...props}>
            {children}
        </Wrapper>
    )
}

export default WrapperComponent;